import React, { Component } from 'react'; 
import pressable from './Assets/button.png'; 
import redButton from './Assets/buttonred.png'; 
import './App.css';



class DrumPad extends Component {

    state = {
        firstImage: pressable
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown); 
        window.focus(); 

    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown); 
    }

    handleKeyDown = event => {
        if(event.keyCode === this.props.letter.charCodeAt()) {
            this.audio.play();
            this.audio.currentTime = 0; 

        if(this.state.firstImage === pressable ) {
            this.setState({firstImage: redButton})
            setTimeout(function(){
                this.setState({firstImage: pressable});
           }.bind(this),100);
        }

        }
    }
    
    
    handleClick = () => {
        this.audio.play(); 
        this.audio.currentTime = 0; 

        if(this.state.firstImage === pressable ) {
            this.setState({firstImage: redButton})
            setTimeout(function(){
                this.setState({firstImage: pressable});
           }.bind(this),100);
        }
    }

    
    
    render() {
        return(
            <div className="drum-pad" id={this.props.id} onClick={this.handleClick}>
                <img src={this.state.firstImage}/> 
                <p>{this.props.id} ({this.props.letter})</p>
                <audio ref ={ref => this.audio = ref} className="clip" src={this.props.src} id={this.props.letter}></audio>
            </div>
        )
    }
}

export default DrumPad; 